import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";

export const fetchGottenCustomers = createAsyncThunk(
  "gottenCustomers/fetchGottenCustomers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `message/GetAllGottenCustomerList`
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchGotton24 = createAsyncThunk(
  "gottenCustomers/getApprovedMessagesCountLast24Hours",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `message/getApprovedMessagesCountLast24Hours`
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchCustomersByMonth = createAsyncThunk(
  "gottenCustomers/fetchCustomersByMonthAndUser",
  async (month, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        `message/fetchCustomersByMonthAndUser`,
        { Month: month } // Pass month as query parameter
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  gottenCustomers: [],
  customerMessages: [], // New state for individual messages
  loading: false,
  error: null,
  messagesLoading: false, // Separate loading state for messages
  messagesError: null, // Separate error state for messages
  clicksTab: "NEEDS",
  gotton24Hr: [], // State for 24-hour gotten customers
  gotton24HrLoading: false, // Loading state for 24-hour gotten customers
  gotton24HrError: null,
  selectedCustomer: null, // Error state for 24-hour gotten customers
};

const ReportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    clearGottenCustomers: (state) => {
      state.gottenCustomers = [];
      state.error = null;
      state.loading = false;
    },
    clearCustomerMessages: (state) => {
      state.customerMessages = [];
      state.messagesError = null;
      state.messagesLoading = false;
    },
    setClicksTab: (state, action) => {
      state.clicksTab = action.payload;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload; // Add setselectedCustomer reducer
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchGottenCustomers
      .addCase(fetchGottenCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGottenCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.gottenCustomers = action.payload;
      })
      .addCase(fetchGottenCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handle fetchCustomersByMonth
      .addCase(fetchCustomersByMonth.pending, (state) => {
        state.messagesLoading = true;
        state.messagesError = null;
      })
      .addCase(fetchCustomersByMonth.fulfilled, (state, action) => {
        state.messagesLoading = false;
        state.customerMessages = action.payload;
      })
      .addCase(fetchCustomersByMonth.rejected, (state, action) => {
        state.messagesLoading = false;
        state.messagesError = action.payload;
      })
      // Handle fetchGotton24
      .addCase(fetchGotton24.pending, (state) => {
        state.gotton24HrLoading = true;
        state.gotton24HrError = null;
      })
      .addCase(fetchGotton24.fulfilled, (state, action) => {
        state.gotton24HrLoading = false;
        state.gotton24Hr = action.payload;
      })
      .addCase(fetchGotton24.rejected, (state, action) => {
        state.gotton24HrLoading = false;
        state.gotton24HrError = action.payload;
      });
  },
});

export const {
  clearGottenCustomers,
  clearCustomerMessages,
  setSelectedCustomer,
  setClicksTab,
} = ReportsSlice.actions;

export default ReportsSlice.reducer;
